import React from "react"
import { PageContent, CustomBreadcrumb } from "components/Common";
import AnalyzerPath from "./AnalyzerPath";
import { ModuleIds } from "constant";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types"

const RESOURCE = ModuleIds.User;

const AnalyzerPathContainer = ({ t }) => {
    const titleTag = t("Danh sách máy trên luồng")
    return (
        <PageContent title={t(titleTag)}>
            {/* Page Title */}
            < CustomBreadcrumb
                breadcrumbItem={titleTag}
                resource={RESOURCE}
                icon={<i className="bx bx-file" />}
            />
            {/* Page Body */}
            <AnalyzerPath />
        </PageContent >
    )
}

AnalyzerPathContainer.propTypes = {
    t: PropTypes.any,
}

export default withTranslation(["sitePage"])(AnalyzerPathContainer)